import { render, staticRenderFns } from "./ModalWarningNotInGrade.vue?vue&type=template&id=616c0b6e&scoped=true"
import script from "./ModalWarningNotInGrade.vue?vue&type=script&lang=js"
export * from "./ModalWarningNotInGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616c0b6e",
  null
  
)

export default component.exports